(function () {
  const STORAGE_KEY = "techaido-saved-products";

  const readProducts = () => {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.filter((item) => item?.id) : [];
    } catch (error) {
      return [];
    }
  };

  const writeProducts = (products) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
    } catch (error) {
      return;
    }
  };

  const emitUpdate = () => {
    window.dispatchEvent(
      new CustomEvent("techaido:saved-products-updated", {
        detail: {
          products: readProducts(),
        },
      }),
    );
  };

  const pushEvent = (eventName, payload = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...payload,
    });
  };

  const updateCounters = () => {
    const count = readProducts().length;

    document.querySelectorAll("[data-saved-products-counter]").forEach((link) => {
      const countNode = link.querySelector("[data-saved-products-count]");
      if (countNode) {
        countNode.textContent = String(count);
      }

      const baseLabelNode =
        link.querySelector(".header__saved-products-label") ||
        link.querySelector("span");

      const baseLabel =
        link.dataset.savedProductsLabel ||
        (baseLabelNode ? baseLabelNode.textContent.trim() : "Saved");

      link.dataset.savedProductsLabel = baseLabel;
      link.setAttribute("aria-label", `${baseLabel} (${count})`);
    });
  };

  const hasProduct = (productId) =>
    readProducts().some((product) => String(product.id) === String(productId));

  const saveProduct = (product) => {
    const products = readProducts();
    if (products.some((item) => String(item.id) === String(product.id))) return;
    products.push({
      id: String(product.id),
      title: product.title || "",
      url: product.url || "",
      vendor: product.vendor || "",
      image: product.image || "",
      imageAlt: product.imageAlt || "",
    });
    writeProducts(products);
    emitUpdate();
  };

  const removeProduct = (productId) => {
    const products = readProducts().filter(
      (product) => String(product.id) !== String(productId),
    );
    writeProducts(products);
    emitUpdate();
  };

  const updateButtonState = (button) => {
    const isSaved = hasProduct(button.dataset.productId);
    button.classList.toggle("is-saved", isSaved);
    button.setAttribute("aria-pressed", isSaved ? "true" : "false");
    button.textContent = isSaved
      ? button.dataset.savedLabel || button.textContent
      : button.dataset.saveLabel || button.textContent;
  };

  const updateAllButtons = () => {
    document.querySelectorAll("[data-saved-product-button]").forEach((button) => {
      updateButtonState(button);
    });

    updateCounters();
  };

  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-saved-product-button]");
    if (!button) return;

    const product = {
      id: button.dataset.productId,
      title: button.dataset.productTitle,
      url: button.dataset.productUrl,
      vendor: button.dataset.productVendor,
      image: button.dataset.productImage,
      imageAlt: button.dataset.productImageAlt,
    };

    const action = hasProduct(product.id) ? "remove" : "save";
    if (action === "save") {
      saveProduct(product);
    } else {
      removeProduct(product.id);
    }

    pushEvent("b2b_saved_product_toggle", {
      saved_product_action: action,
      product_id: product.id || "",
      product_title: product.title || "",
      product_vendor: product.vendor || "",
    });

    updateAllButtons();
  });

  window.addEventListener("techaido:saved-products-updated", updateAllButtons);
  document.addEventListener("DOMContentLoaded", updateAllButtons);

  window.TechaidoSavedProducts = {
    key: STORAGE_KEY,
    getAll: readProducts,
    has: hasProduct,
    save: saveProduct,
    remove: removeProduct,
  };
})();
